import { graphql } from "relay-runtime"

export const chUpdatePatientFamilyHistoryMutation = graphql`
  mutation chUpdatePatientFamilyHistoryMutation($input: Ch_updatePatientFamilyHistoryInput!) {
    updatePatientFamilyHistory: ch_updatePatientFamilyHistory(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      familyHistory {
        ...FamilyHistoryFragment
      }
    }
  }
`
